module.exports = __webpack_public_path__ + "2023124:cb48231cec1aa2d91890/img/hero-mobile@2x.15234e9.jpg";